import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: "fullName"
})
export class FullNamePipe implements PipeTransform {
    transform(source: any, isInitialOnly: boolean = false) {
        if (!source) return '';
        if (!getFirstName(source) && !getLastName(source)) return fallbackName(source);
        return formatName(source, isInitialOnly);
    }
}


function getFirstName(source) {
    return source.first || source.FirstName || source.firstName;
}

function getLastName(source) {
    return source.last || source.LastName || source.lastName;
}

function formatName(source, isInitialOnly) {
    var name = getFirstName(source);
    if (getLastName(source)) name += ' ' + (isInitialOnly ? (getLastName(source).substring(0, 1) + ".") : getLastName(source));
    return name;
}

// Fallback display when no first/last name is present, so records identified
// only by other PII still render a meaningful label.
function fallbackName(source) {
    if (source.email || source.Email) return source.email || source.Email;
    if (source.crsNumber || source.crs_number) return 'CRS# ' + (source.crsNumber || source.crs_number);
    if (source.pmsNumber || source.pms_number) return 'PMS# ' + (source.pmsNumber || source.pms_number);
    return '';
}